define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../models/IpAddressModel", "../../models/UserContext", "../../utils/dateUtils"], function (require, exports, $, ko, log, tools, IpAddressModel, UserContext, dateUtils) {
    "use strict";
    var FirewallActions = /** @class */ (function () {
        function FirewallActions() {
            this.editModel = ko.observable(new IpAddressModel());
            this.deleteModel = ko.observable(new IpAddressModel());
            this.editFromCustomer = ko.observable(false);
            this.userCanViewFirewall = ko.observable(UserContext.hasAccess("Admin,CustomerFirewall.View,CustomerFirewall.Edit,CustomerFirewall.Delete"));
            this.userCanEditFirewall = ko.observable(UserContext.hasAccess("Admin,CustomerFirewall.Edit,CustomerFirewall.Delete"));
            this.userCanDeleteFirewall = ko.observable(UserContext.hasAccess("Admin,CustomerFirewall.Delete"));
        }
        FirewallActions.prototype.init = function () {
        };
        FirewallActions.prototype.editIpAddress = function (theId, name, customerId) {
            var self = this;
            var title = "Add IP Address";
            if ($.isNumeric(theId) && name) {
                title = "Edit IP Address " + name + " Details";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().IpAddress()) {
                        tools.error("Ip Address is required");
                        return;
                    }
                    if (!self.editModel().GroupName()) {
                        tools.error("Group is required");
                        return;
                    }
                    if (!self.editModel().EndOn()) {
                        tools.error("End date is required field");
                        return;
                    }
                    if (self.editModel().StartOn() && self.editModel().EndOn() && self.editModel().StartOn() > self.editModel().EndOn()) {
                        tools.error("Period start date must be greater than end date");
                        return;
                    }
                    if (self.editModel().EndOn() && dateUtils.today() > self.editModel().EndOn()) {
                        tools.error("Period end date must be equal or greater than today");
                        return;
                    }
                    if (self.editModel().NotifyExpiration() && self.editModel().Recipients().length === 0) {
                        tools.error("Recipients field is required if Notify option is ON");
                        return;
                    }
                    if (self.editModel().NotifyExpiration() && self.editModel().Recipients().length > 0) {
                        var hasBadEmail = false;
                        for (var _i = 0, _a = self.editModel().Recipients(); _i < _a.length; _i++) {
                            var email = _a[_i];
                            if (!tools.isValidEmail(email)) {
                                tools.error('Recipient email address "' + email + '" is not valid email address');
                                hasBadEmail = true;
                                break;
                            }
                        }
                        if (hasBadEmail) {
                            return;
                        }
                    }
                    $(event.currentTarget).button("loading");
                    self.saveIpAddress(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if ($.isNumeric(theId)) {
                        getModelCall = tools.ajaxGet({
                            url: "/Firewall/GetById",
                            data: { id: theId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new IpAddressModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new IpAddressModel());
                        if (customerId) {
                            self.editModel().CustomerId(customerId);
                        }
                    }
                    var getLookupData = tools.ajaxGet({
                        url: "/Firewall/GetFirewallLookupData",
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getModelCall, getLookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'ipaddress-edit-template', data: editModel }\"></div>");
                        if (self.editModel().Id() <= 0) {
                            self.editModel().GroupName(self.lookupLists.DefaultGroup);
                        }
                        ko.applyBindings(self, modal);
                        self.customerDropDownList = $("#CustomerId", modal).kendoComboBox({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            dataTextField: "Text",
                            dataValueField: "Value",
                            dataSource: {
                                transport: {
                                    read: {
                                        url: "/Customers/GetCustomersLookup",
                                        type: "POST",
                                        dataType: "json"
                                    }
                                },
                                schema: {
                                    data: function (response) { return response.Data; },
                                    total: "Total"
                                },
                                serverFiltering: true
                            },
                            dataBound: function () {
                                //$(window).trigger("resize");
                                log.log("dataBound");
                            },
                            change: function (e) {
                                log.log("change", e);
                                if (e.sender.dataItem()) {
                                    self.editModel().CustomerId(e.sender.dataItem().Value);
                                }
                                else {
                                    self.editModel().CustomerId(0);
                                }
                            }
                        }).data("kendoComboBox");
                        if (self.customerDropDownList) {
                            self.customerDropDownList.value(self.editModel().CustomerId());
                        }
                    });
                }
            });
        };
        FirewallActions.prototype.saveIpAddress = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.toJS(self.editModel);
            if (obj["StartOn"]) {
                obj["StartOn"] = dateUtils.toIsoString(obj["StartOn"]);
            }
            if (obj["EndOn"]) {
                obj["EndOn"] = dateUtils.toIsoString(obj["EndOn"]);
            }
            obj["Recipients"] = self.editModel().Recipients();
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Firewall/SaveIpAddress",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (_this.saveCallback) {
                        _this.saveCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        FirewallActions.prototype.deleteServerConfirm = function (theId, name) {
            var self = this;
            tools.confirmModal({
                title: "Remove IP Address - " + name,
                text: "Are you sure you want to Remove IP Address?",
                buttonTitle: "Remove",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.removeIpAddress(theId);
            });
        };
        FirewallActions.prototype.removeIpAddress = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Firewall/DeleteConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("IP address deleted successfully");
                    if (self.deleteCallback) {
                        self.deleteCallback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
            });
        };
        FirewallActions.prototype.syncGroup = function (group, cb) {
            var data = {
                group: group
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Firewall/SyncGroup",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Group synced successfully");
                }
                else {
                    tools.error(result.Error);
                }
                if (cb) {
                    cb(result);
                }
            });
        };
        return FirewallActions;
    }());
    return FirewallActions;
});
//# sourceMappingURL=firewallActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/firewall/firewallActions.js
// module id = 83
// module chunks = 2